import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FORM_POST_HEADERS } from '../../config/constants';
import { OV_SUBSCRIBE_URL } from '../../config/theme';
import subscribeCache from '../../utils/newsletters/subscribeCache';
import toSearchParams from '../../utils/objects/toSearchParams';
import validEmail from '../../utils/strings/validEmail';
import { jsx as _jsx } from "react/jsx-runtime";

var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}; // A higher order component for newsletter components
// https://facebook.github.io/react/docs/higher-order-components.html


export default function withNewsletter(Component) {
  // ...and returns another component...
  var WithNewsletter = /*#__PURE__*/function (_PureComponent) {
    _inherits(WithNewsletter, _PureComponent);

    var _super = _createSuper(WithNewsletter);

    function WithNewsletter(props) {
      var _this;

      _classCallCheck(this, WithNewsletter);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "onEmailEnter", function (event) {
        _this.setState({
          email: event.target.value
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onSubmitError", function () {
        _this.setState({
          error: true,
          fetching: false
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onSubmitted", function () {
        subscribeCache();

        _this.setState({
          fetching: false,
          loaded: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "submit", function (body) {
        var email = _this.state.email;
        var valid = validEmail(email);

        if (!valid) {
          return false;
        }

        _this.setState({
          fetching: true
        });

        fetch(OV_SUBSCRIBE_URL, _objectSpread(_objectSpread({}, FORM_POST_HEADERS), {}, {
          body: toSearchParams(body)
        })).then(function (response) {
          if (!response.ok) {
            return _this.onSubmitError(response);
          }

          return response;
        }).then(function (response) {
          return _this.onSubmitted(response);
        }).catch(_this.onSubmitError);
        return false;
      });

      var CUSTOMER = window.OV.CUSTOMER;
      var loggedInUserEmail = CUSTOMER.email,
          loggedIn = CUSTOMER.loggedIn;

      var _email = loggedIn && loggedInUserEmail ? loggedInUserEmail : '';

      _this.state = {
        email: _email,
        error: false,
        fetching: false,
        loaded: false
      };
      return _this;
    }

    _createClass(WithNewsletter, [{
      key: "render",
      value: function render() {
        var _this$state = this.state,
            email = _this$state.email,
            error = _this$state.error,
            fetching = _this$state.fetching,
            loaded = _this$state.loaded;
        return /*#__PURE__*/_jsx(Component, _objectSpread({
          email: email,
          error: error,
          fetching: fetching,
          loaded: loaded,
          onEmailEnter: this.onEmailEnter,
          submit: this.submit
        }, this.props));
      }
    }]);

    return WithNewsletter;
  }(PureComponent);

  WithNewsletter.displayName = "WithNewsletter(".concat(getDisplayName(Component), ")");
  WithNewsletter.defaultProps = {
    utmCampaign: Cookies.get('ov-utm-campaign'),
    utmMedium: Cookies.get('ov-utm-medium'),
    utmSource: Cookies.get('ov-utm-source')
  };
  WithNewsletter.propTypes = {
    utmCampaign: PropTypes.string,
    utmMedium: PropTypes.string,
    utmSource: PropTypes.string
  };
  return WithNewsletter;
}